export const provideErrorContentForValidator = error => {
  if (error?.line) return `Error on line ${error.line} wrong syntax`;
  return error?.message;
};
export const isLink = str => {
  const urlPattern = /^["']?(www\.|http:\/\/|https:\/\/|ftp:\/\/)\S*["']?$/;
  return urlPattern.test(str);
};
export const messageError = error => {
  if (!error.message) {
    return {
      message: error.message
    };
  }
  const message = error.message.replace(/^JSON.parse: /, "").replace(/of the JSON data/, "");
  const parts = /line (\d+) column (\d+)/.exec(message);
  if (!parts || parts.length !== 3) {
    return error;
  }
  return {
    message: message,
    line: Number(parts[1]),
    column: Number(parts[2])
  };
};
export const convertToJSONString = input => {
  const inputString = typeof input === "string" ? input : JSON.stringify(input);
  try {
    const parsed = JSON.parse(inputString);
    return JSON.stringify(parsed);
  } catch (error) {
    return inputString;
  }
};
export const prettyPrintJSON = jsonString => {
  try {
    const jsonObject = JSON.parse(convertToJSONString(jsonString));
    return {
      error: undefined,
      data: jsonObject
    };
  } catch (error) {
    return {
      error: error,
      data: jsonString
    };
  }
};